import React from 'react';

const About = () => {
    return (
        <div>
            <h4 className='text-center'>About Us Page</h4>
        </div>
    );
};

export default About;